import {scopeGapi, discoveryDocs} from '@/constants/googleApi/scopeGapi'
import delegateEmails from '@/constants/googleApi/delegateEmails'
import keysGapi from '@/constants/googleApi/keysGapi'
import serverAccountKeysGapi from '@/constants/googleApi/serviceAccountKeys'
import {find} from 'lodash'

export default {
  computed: {
    configApiKeys: {
      get: function () {
        return this.$store.getters.configApiKeys
      },
      set: function (data) {
        this.$store.dispatch('setConfigApiKeys', data)
      }
    }
  },
  methods: {
    getServerNameForApi (mail) {
      const domainsOptions = [
        {server: 'prod', domain: '@uae-consulting.com'},
        {server: 'prodConsultants', domain: '@uae-consultants.com'},
        {server: 'local', domain: '@webfriends.by'}
      ]
      const hostname = window.location.hostname
      const defaultKeys = {
        'b-b.center': 'prod',
        'stg.b-b.center': 'local',
        'stg-bb.tk': 'local',
        '0.0.0.0': 'local',
        'localhost': 'local'
      }
      const result = find(domainsOptions, domain => {
        const reg = new RegExp(domain.domain, 'gmi')
        return reg.test(mail)
      }) || {}
      return result.server || defaultKeys[hostname]
    },
    getConfigGapi (email) {
      // server = local || stg || prod || prodConsultants
      const server = this.getServerNameForApi(email)
      const configGapi = {
        apiKey: keysGapi[server].apiKey,
        clientId: keysGapi[server].clientId,
        discoveryDocs: discoveryDocs,
        scope: scopeGapi
      }
      const projectId = keysGapi[server].projectId
      const subscriptionId = keysGapi[server].subscriptionId
      const topicId = keysGapi[server].topicId
      const serverAccountKey = serverAccountKeysGapi[server]
      const sendAsGmail = delegateEmails[server]
      const result = {
        projectId,
        subscriptionId,
        topicId,
        serverAccountKey,
        sendAsGmail,
        configGapi
      }
      this.configApiKeys = result
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getConfigGapi.js